/**
 * Константы для алиасов методов оплаты
 * Используются для отображения понятных пользователю названий
 * 
 * NOTE: Отладочные console.log можно удалить после проверки работы алиасов
 */
export const PAYMENT_METHOD_ALIASES: Record<string, string> = {
  // Алиасы на основе реальных методов оплаты
  'СБП + Карта + Т-Банк': 'СБП-приложение любого банка',
  'Карта + SberPay': 'Карта', 
  'Внутренний баланс': 'Внутренний баланс',
  
  // Дополнительные алиасы для других возможных методов
  'YOOKASSA': 'ЮKassa',
  'TBANK': 'Т-Банк',
  'BALANCE': 'Баланс',
  'SBERPAY': 'SberPay',
  'QIWI': 'QIWI',
  'WEBMONEY': 'WebMoney',
  'PAYPAL': 'PayPal'
}

/**
 * Получить отображаемое имя метода оплаты
 * @param name - оригинальное имя метода
 * @param alias - алиас из API (если есть)
 * @returns отображаемое имя
 */
export function getPaymentMethodDisplayName(name: string, alias?: string): string {
  // Приоритет: alias из API > алиас из констант > оригинальное имя
  if (alias) {
    console.log(`[PaymentAlias] Используется alias из API: "${name}" → "${alias}"`)
    return alias
  }
  
  // Ищем точное совпадение по ключу (без изменения регистра)
  const foundAlias = PAYMENT_METHOD_ALIASES[name]
  if (foundAlias) {
    console.log(`[PaymentAlias] Найден алиас в константах: "${name}" → "${foundAlias}"`)
    return foundAlias
  }
  
  console.log(`[PaymentAlias] Алиас не найден, используется оригинальное имя: "${name}"`)
  return name
}

/**
 * Получить отображаемое имя метода оплаты (версия без отладки)
 * Используйте эту функцию вместо getPaymentMethodDisplayName после того, как убедитесь что алиасы работают
 */
export function getPaymentMethodDisplayNameSilent(name: string, alias?: string): string {
  if (alias) {
    return alias
  }
  return PAYMENT_METHOD_ALIASES[name] || name
}

/**
 * Получить алиас для метода по коду
 * @param methodCode - код метода оплаты
 * @returns алиас или null если не найден
 */
export function getPaymentMethodAliasByCode(methodCode: string): string | null {
  // Для технических кодов используем верхний регистр
  const upperCode = methodCode.toUpperCase()
  return PAYMENT_METHOD_ALIASES[upperCode] || PAYMENT_METHOD_ALIASES[methodCode] || null
}

/**
 * Обработать массив методов оплаты, добавив отображаемые имена
 * @param methods - массив методов оплаты
 * @returns массив методов с добавленными displayName
 */
export function processPaymentMethods<T extends { name: string; alias?: string }>(
  methods: T[]
): (T & { displayName: string })[] {
  return methods.map(method => ({
    ...method,
    displayName: getPaymentMethodDisplayName(method.name, method.alias)
  }))
}
